import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CTable from "components/CTable";
import useAjax from "helpers/ajax";
import {
  getStatus,
  showConfirm,
  showError,
  showMessage,
} from "helpers/utility";
import { Button, Tooltip } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  FileProtectOutlined,
} from "@ant-design/icons";
import Toolbar from "components/Toolbar";

const Roles = () => {
  const navigate = useNavigate();
  const { get, del } = useAjax();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = () => {
    get("api/v1/roles")
      .then((resp) => {
        setData(resp);
      })
      .catch((err) => {
        showError(err);
      })
      .finally(() => setLoading(false));
  };

  const onDelete = (record) => {
    showConfirm("Data once deleted can not be restored.").then(() => {
      del("api/v1/roles", { key: record.roleID })
        .then((resp) => {
          // reload data
          loadData();
          showMessage(resp.success, resp.message);
        })
        .catch((err) => {
          showError(err);
        });
    });
  };

  const columns = [
    {
      title: "Role name",
      dataIndex: "roleName",
    },
    {
      title: "Status",
      dataIndex: "active",
      width: "80px",
      render: (text) => getStatus(text),
    },
    {
      title: "Actions",
      width: "65px",
      align: "center",
      render: (text, record) => (
        <Button.Group>
          <Tooltip placement="topLeft" title="Permissions">
            <Button
              type="primary"
              size="small"
              icon={<FileProtectOutlined />}
              danger
              onClick={() => {
                navigate(`/security/roles/permissions/${record.roleID}`, {
                  state: record,
                });
              }}
            />
          </Tooltip>
          <Tooltip placement="topLeft" title="Edit">
            <Button
              type="primary"
              size="small"
              icon={<EditOutlined />}
              onClick={() => {
                navigate(`/security/roles/edit/${record.roleID}`, {
                  state: record,
                });
              }}
            />
          </Tooltip>
          <Tooltip placement="topLeft" title="Delete">
            <Button
              type="danger"
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => onDelete(record)}
              disabled={record.isSystem}
            />
          </Tooltip>
        </Button.Group>
      ),
    },
  ];

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Toolbar>
        <Button
          type="primary"
          onClick={() => {
            navigate("/security/roles/create");
          }}
        >
          Create
        </Button>
      </Toolbar>
      <CTable
        rowKey="roleID"
        columns={columns}
        dataSource={data}
        loading={loading}
      />
    </div>
  );
};
export default Roles;
